import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useCustomerMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation('toggleCustomerStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  const { mutateAsync: resetPassword } = useMutation('resetPassword', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  const { mutateAsync: deleteCustomer } = useMutation('deleteCustomer', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { mutateAsync, resetPassword, deleteCustomer };
};

export default useCustomerMutation;
